import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation, useParams } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
import { SessionModel } from '../../models/SessionModel';
import * as AppointmentsMdls from '../../models/PendingAppointmentModel';
import * as AppointmentsStore from '../../store/PendingAppointment';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect } from 'react';

type MyProps =
    { Appointments: AppointmentsMdls.PendingAppointmentList, SessionState: SessionModel } & typeof AppointmentsStore.actionCreators;


const PendingAppointments: React.FunctionComponent<MyProps> = (props: MyProps) => {
    
    useEffect(() => {
        props.loadAppointments();      
    }, []);


    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.Appointments.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            {props.Appointments.items.map((item, index) =>
                <Row key={index} >
                    <Col xs={12}>
                        <PendingAppointmentCard item={item}> </PendingAppointmentCard>
                    </Col>
                </Row>
            )}           
        </Container>
    );
}

const PendingAppointmentCard: React.FunctionComponent<{ item: AppointmentsMdls.PendingAppointmentModel }> = (props: { item: AppointmentsMdls.PendingAppointmentModel }) => {

    return (<Card className='pendingAppointment-card'>
        <CardHeader>
            <Row>
                <Col xs="6">
                    {props.item.personCalling} 
                </Col>
                <Col xs="6" className="right-align">
                    {props.item.personCallingContactNumber}
                </Col>
            </Row>
        </CardHeader>
        <CardBody>
            <Row>
                <Col xs="6">
                    <SaLabel Text={"Start Date"} /> {props.item.datePromisedStart}
            </Col>
            <Col xs="6" className="right-align">
                    <SaLabel Text={"End Date"} /> {props.item.datePromisedEnd}
                </Col>
            </Row>
            <Row>               
                    <Col xs="6">
                    <SaLabel Text={"Time Promised"} /> {props.item.timePromised}
                    </Col>
                    <Col xs="6" className="right-align">
                    <SaLabel Text={"Task"} /> {props.item.taskDescription}
                    </Col>
            </Row>
        </CardBody>
    </Card>);
}

export default connect(
    (state: ApplicationState) => ({ Appointments: state.pendingAppointmentState, SessionState: state.sessionState }),
    AppointmentsStore.actionCreators)(PendingAppointments as any);
